import { render } from "./press-article.vue?vue&type=template&id=6dc46420"
import script from "./press-article.vue?vue&type=script&setup=true&lang=js"
export * from "./press-article.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/in-the-press/press-article.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6dc46420"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6dc46420', __exports__)) {
    api.reload('6dc46420', __exports__)
  }
  
  module.hot.accept("./press-article.vue?vue&type=template&id=6dc46420", () => {
    api.rerender('6dc46420', render)
  })

}


export default __exports__